import { Key, useState } from 'react'
import { TodoAssigneePickerPopoverContentProps } from './Types'
import { Item } from '@react-stately/collections'
import { TodoUser } from 'api/clients/TodoClient'
import Avatar from 'common/Avatar/Avatar'
import { InlineComboBox } from 'components/ComboBox/InlineComboBox'
import Styles from './TodoAssigneePicker.module.scss'
import { ReactComponent as UnassignedIcon } from 'assets/icons/addMember16.svg'
import { useWorkspaceUsers } from 'hooks/queries/companies/users/useWorkspaceUsers'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

const TodoAssigneePickerPopoverContent = ({ value, onChange, placeholder }: TodoAssigneePickerPopoverContentProps) => {
  const currentWorkspace = useCurrentWorkspace()
  const { data: users = [] } = useWorkspaceUsers({ workspaceKey: currentWorkspace?.key })
  const [query, setQuery] = useState('')

  const handleSelectionChange = (key: Key | null) => {
    if (key === 'unassigned') {
      onChange(null)
      return
    }
    const user = users.find((user) => user.id === parseInt(key as string))
    if (!user) return
    onChange(user as TodoUser)
  }

  return (
    <InlineComboBox
      label="Assign to"
      onInputChange={setQuery}
      inputValue={query}
      onSelectionChange={handleSelectionChange}
      selectedKey={value?.id.toString() || 'unassigned'}
      placeholder={placeholder}
    >
      {[
        <Item key="unassigned" textValue="Unassigned">
          <UnassignedIcon className={Styles.unassignedIcon} />
          <span className={Styles.listItemText}>Unassigned</span>
        </Item>,
        ...users.map((user) => (
          <Item key={user.id} textValue={user.display_name || user.email}>
            <Avatar size={20} url={user.avatar_url} />
            <span className={Styles.listItemText}>{user.display_name}</span>
          </Item>
        )),
      ]}
    </InlineComboBox>
  )
}

export { TodoAssigneePickerPopoverContent }
